<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("grupo-economico") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda
                                            ? $t("vendas")
                                            : $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: isVenda
                                                    ? 'ven-grupoeconomico'
                                                    : `cli-grupoeconomico`,
                                            })
                                        "
                                        >{{ $t("grupo-economico") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: isVenda
                                        ? 'ven-grupoeconomico-list'
                                        : 'cli-grupoeconomico',
                                })
                            "
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao &&
                                    !isUpdate &&
                                    permissao.create) ||
                                (!usuarioIntegracao &&
                                    isUpdate &&
                                    permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(9)"
                                ref="idErpInput"
                                v-model="grupoeconomico.idgrupoeconomicoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                tooltipLabel="cod-ref"
                                uppercase
                                :invalid="!grupoeconomico.idgrupoeconomicoerp"
                                :disabled="usuarioIntegracao"
                                required
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="grupoeconomico.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="grupo-economico"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grupoeconomico.descricao"
                                :required="true"
                                tooltipLabel="informacao-grupo-economico-descricao"
                                tooltipSize="is-small"
                                :disabled="cantEdit || usuarioIntegracao"
                            />
                        </div>
                        <div class="column is-2">
                            <label
                                for="situacao"
                                v-text="$t('situacao')"
                            />
                            <vss-select
                                :id="generateId(2)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="grupoeconomico.id == null || usuarioIntegracao"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GrupoEconomicoService from "@/services/agro/GrupoEconomicoService";
import GrupoEconomicoValidation from "@/services/validations/GrupoEconomicoValidation";
import Message from "@/models/Message";

export default {
    data() {
        return {
            usuarioIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "CLI_GRUPOECONOMICO"
                ),
            service: new GrupoEconomicoService(this.$http, this.$router),
            validations: new GrupoEconomicoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            grupoeconomico: {
                id: null,
                idgrupoeconomicoerp: null,
                descricao: null,
                situacao: null,
            },
            isUpdate: false,
            cantEdit: false,
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            situacao: { label: "ativo", id: 1 },
            isVenda: "vendas" === this.$route.meta.contexto ? true : false,
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.isVenda
            ? this.hasPermissionAccess(
                  "vendas",
                  "clientes",
                  "ven-grupoeconomico"
              )
            : this.hasPermissionAccess(
                  "agro",
                  "agro-cadastros",
                  "cli-grupoeconomico"
              );

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "grupoeconomico" },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados();
                this.cantEdit = !this.permissao.update;
            } else {
                // para carregar o vss-select de cidade e carregar o campo situacao
                this.situacoes[this.situacao];
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.grupoeconomico = Object.assign({}, value.content);
                    this.situacao =
                        this.situacoes[this.grupoeconomico.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.$emit("isChanged", false);
                    }, 300);
                    this.runValidations(true);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
        },
        save() {
            this.isLoading = true;
            let grupoeconomicoTemp = Object.assign({}, this.grupoeconomico);
            grupoeconomicoTemp = this.mapTosave(grupoeconomicoTemp);
            grupoeconomicoTemp.situacao = this.situacao.id;

            if (this.validations.validate(grupoeconomicoTemp, this.$refs)) {
                this.invalidIcon = false;
                this.isSaving = true;
                this.service
                    .save(grupoeconomicoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = "msg-save-grupo-economico";
                            if (this.grupoeconomico.id != null) {
                                msg = "msg-edit-grupo-economico";
                            }
                            this.msgs.push(new Message("success", msg, true));
                            this.redirectToList();
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message("error", "msg-problema-realizar-acao", true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body && e.body.message && this.$te(e.body.message)) {
                            let message = e.body.message;
                            let msgErro;
                            if (message == "msg-codigo-duplicado-n") {
                                msgErro = this.$t(e.body.message, { n: grupoeconomicoTemp.idgrupoeconomicoerp });
                            } else {
                                msgErro = this.$t(message);
                            }
                            this.msgs.push(new Message("alert", msgErro, true, false));
                        } else {
                            this.msgs.push(
                                new Message("error", "msg-problema-realizar-acao", true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isLoading = false;
            }
        },
        redirectToList() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == "retricao-forncedor") {
                //aba de onde veio
                tempTela = "agro-cliente-politica-comercial-edit"; // rota da tela que vai voltar
                tempAba = this.isVenda ? "ven-grupoeconomico" : "cli-grupoeconomico"; // aba da tela que retorna
            } else {
                tempTela = this.isVenda? "ven-grupoeconomico" : "cli-grupoeconomico";
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query["id"] },
                    query: { abaSelecionada: tempAba },
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
    .nome-input {
        width: 49.5%;
    }
    .razao-social-input {
        width: 49.5%;
    }
}
</style>
